export async function fetchCuotas(slug) {
    const res = await fetch(`/api/quotas/${slug}`);
    const data = await res.json();

    if (data.error) {
        console.error("Error al obtener cuotas:", data.error);
        return null;
    }

    return {
        valorUF: data.valor_uf,
        cuotasData: data.cuotas,
    };
}
